

export const tableWork = [
    {
        id: 1,
        title: "ADLYZERRA",
        link: "https://adlyzerra.com/",
        category: ["E-comm", "Corporate"],

        img: "adlyzerra"
    },
    {
        id: 2,
        title: "SKYABS",
        link: "https://task-five-azure.vercel.app/",
        category: ["Landing", "Corporate"],

        img: "skyads"
    },
    {
        id: 3,
        title: "LIFTSHOP-ZB",
        link: "https://liftoff-zb.vercel.app/en/",
        category: ["E-comm"],

        img: "liftshop-zb"
    },
    {
        id: 4,
        title: "AUTO EXPRESS",
        link: "https://auto-express-iota.vercel.app/",
        category: ["Landing"],

        img: "car"
    },
    {
        id: 5,
        title: "RITM STYLE",
        link: "https://ritm-style-delta.vercel.app/",
        category: ["Corporate"],

        img: "ritmstyle"
    },
    {
        id: 6,
        title: "COMPUTER ASSEMBLY",
        link: "https://computer-assembly.vercel.app/",
        category: ["Landing"],

        img: "comp"
    },
    {
        id: 7,
        title: "ADVANCED IT STUDIO",
        link: "https://advanced-it-studio.vercel.app/",
        category: ["Landing"],

        img: "dv"
    },
    {
        id: 8,
        title: "TERRACOTTA",
        link: "https://catalog-gamma.vercel.app/",
        category: ["E-comm"],

        img: "terracotta"
    },
    {
        id: 9,
        title: "PORTFOLIO",
        link: "https://portfolio-den.vercel.app/",
        category: ["Landing", "Corporate"],

        img: "pr"
    },
    {
        id: 10,
        title: "DIGITAL SERVICE",
        link: "https://company-eosin.vercel.app/",
        category: ["Corporate"],

        img: "company"
    },
    {
        id: 11,
        title: "BOOSTING SERVICE",
        link: "https://game-site-chi.vercel.app/",
        category: ["Landing"],

        img: "boost"
    }
]
